import { FC, useContext, useEffect } from "react";

import { Datebox, Form, SubmitButton, Textbox, useForm } from "capitalrx-components-2.0/lib/forms";
import { Message, Messages } from "capitalrx-components-2.0/lib/general";
import { Grid, Shelf, Stack, useResponsive } from "capitalrx-components-2.0/lib/layout";

import { ThemeSelectorContext } from "@/context";
import { getThemeButton } from "@/utils";

type AccessFormValues = {
  unique_code: string;
  patient_date_of_birth: string;
  patient_last_name: string;
}

type AccessFormProps = {
  errorVisible: boolean;
  submitHandler: (values: AccessFormValues) => Promise<void>;
}

const PACaseDraftAccessForm: FC<AccessFormProps> = ({ errorVisible, submitHandler }) => {
  const { primary_color } = useContext(ThemeSelectorContext);

  const { nine_nine_twelve_columns } = useResponsive({
    nine_nine_twelve_columns: {
      desktop: 9,
      tablet: 9,
      mobile: 12,
    },
  });

  const draftAccessForm = useForm<AccessFormValues>();

  useEffect(() => {
    const uniqueCodeFromURL = new URLSearchParams(window.location.search).get("unique_code") ?? "";

    draftAccessForm.setValue("unique_code", uniqueCodeFromURL);
  }, [draftAccessForm]);

  return (
    <Form form={draftAccessForm} onSubmit={submitHandler}>
      <div style={{ marginTop: "32px" }} />
      <Stack spacing="large">
        <Message appearance={Messages.Error} visible={errorVisible} data-testid="test__pa_case_draft_access_form_input_invalid_message">
          Invalid Information
        </Message>
        <Stack>
          <Grid>
            <Grid.Span columns={nine_nine_twelve_columns}>
              <Textbox.Field label="Access Code" name="unique_code" required data-testid="test__pa_case_draft_access_form_unique_code_input" />
            </Grid.Span>
          </Grid>
          <Grid>
            <Grid.Span columns={nine_nine_twelve_columns}>
              <Datebox.Field
                label="Patient Date of Birth"
                name="patient_date_of_birth"
                required
                instructions="mm/dd/yyyy"
                data-testid="test__pa_case_draft_access_form_patient_dob_input"
              />
            </Grid.Span>
          </Grid>
          <Grid>
            <Grid.Span columns={nine_nine_twelve_columns}>
              <Textbox.Field
                label="Patient Last Name"
                name="patient_last_name"
                required
                data-testid="test__pa_case_draft_access_form_patient_last_name_input"
              />
            </Grid.Span>
          </Grid>
        </Stack>
        <Shelf spacing="small">
          <SubmitButton appearance={getThemeButton("primary", primary_color)}>Submit</SubmitButton>
          <Shelf.Spacer />
        </Shelf>
      </Stack>
    </Form>
  );
};

export default PACaseDraftAccessForm;
